import React from 'react';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';

export default function MusicLoader({ open }) {
    return (
        <Backdrop
            sx={{
                zIndex: 1400,
                backgroundColor: 'rgba(15, 17, 23, 0.9)',
                backdropFilter: 'blur(12px)',
                flexDirection: 'column',
                gap: 0,
            }}
            open={open}
        >
            {/* Ambient glow */}
            <Box
                sx={{
                    position: 'absolute',
                    width: 300,
                    height: 300,
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(108,99,255,0.15) 0%, transparent 70%)',
                    filter: 'blur(40px)',
                    animation: 'loaderGlow 3s ease-in-out infinite',
                    '@keyframes loaderGlow': {
                        '0%, 100%': { opacity: 0.5, transform: 'scale(0.9)' },
                        '50%': { opacity: 1, transform: 'scale(1.1)' },
                    },
                }}
            />

            {/* Circular ring */}
            <Box
                sx={{
                    position: 'relative',
                    width: 120,
                    height: 120,
                    mb: 4,
                }}
            >
                {/* Outer spinning ring */}
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        border: '2px solid rgba(108,99,255,0.1)',
                        borderTopColor: '#6C63FF',
                        borderRightColor: '#8B5CF6',
                        animation: 'ringSpin 1.5s linear infinite, outerColor 4s ease-in-out infinite',
                        '@keyframes ringSpin': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(360deg)' },
                        },
                        '@keyframes outerColor': {
                            '0%, 100%': { borderTopColor: '#6C63FF', borderRightColor: '#8B5CF6' },
                            '33%': { borderTopColor: '#10B981', borderRightColor: '#34D399' },
                            '66%': { borderTopColor: '#F59E0B', borderRightColor: '#FBBF24' },
                        },
                    }}
                />

                {/* Inner reverse ring */}
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 12,
                        borderRadius: '50%',
                        border: '2px solid rgba(108,99,255,0.06)',
                        borderBottomColor: '#A78BFA',
                        borderLeftColor: '#6C63FF',
                        animation: 'ringSpinReverse 2s linear infinite, innerColor 4s ease-in-out 0.5s infinite',
                        '@keyframes ringSpinReverse': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(-360deg)' },
                        },
                        '@keyframes innerColor': {
                            '0%, 100%': { borderBottomColor: '#A78BFA', borderLeftColor: '#6C63FF' },
                            '33%': { borderBottomColor: '#F472B6', borderLeftColor: '#EC4899' },
                            '66%': { borderBottomColor: '#38BDF8', borderLeftColor: '#0EA5E9' },
                        },
                    }}
                />

                {/* Center music note */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        filter: 'drop-shadow(0 0 20px rgba(108,99,255,0.5))',
                        animation: 'centerPulse 1.5s ease-in-out infinite',
                        '@keyframes centerPulse': {
                            '0%, 100%': { transform: 'translate(-50%, -50%) scale(1)', filter: 'drop-shadow(0 0 20px rgba(108,99,255,0.5))' },
                            '50%': { transform: 'translate(-50%, -50%) scale(1.3)', filter: 'drop-shadow(0 0 30px rgba(108,99,255,0.8))' },
                        },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <defs>
                            <linearGradient id="noteGrad" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#6C63FF" />
                                <stop offset="100%" stopColor="#8B5CF6" />
                            </linearGradient>
                        </defs>
                        <path d="M12 3v12.26A4.5 4.5 0 1 0 14 19V8h4V3h-6z" fill="url(#noteGrad)" />
                    </svg>
                </Box>
            </Box>

        </Backdrop>
    );
}
